import request from '../../utils/request'
const renewal = (data) => {
    return request({
        url: process.env.VUE_APP_API +  `renewal/policy/common/${data}`,
        method: 'get',
    })
}
const getLastIdentity = (data) => {
    return request({
        url: process.env.VUE_APP_API +  `policy/last-identity?tmpl=${data}`,
        method: 'get',
    })
}

export {
    renewal,
    getLastIdentity
}